const BirthUtils = {
  isValid: (birth: string) => {
    const dateRegex = /^\d{8}$/;
    if (!dateRegex.test(birth)) {
      return false;
    }

    const year = parseInt(birth.substring(0, 4), 10);
    const month = parseInt(birth.substring(4, 6), 10);
    const day = parseInt(birth.substring(6, 8), 10);

    const date = new Date(year, month - 1, day); // JavaScript에서 월은 0부터 시작
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  },
};

export default BirthUtils;
